import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/edit-box-blue.svg'


const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "title-city border-grey-2 py-2 px-4 mb-4 background-grey-2" }
const _hoisted_3 = { class: "flex items-center gap-4 icon-action" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Terminal'), -1)
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "table-terminals" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nama Halte/Terminal"),
    /*#__PURE__*/_createElementVNode("th", null, "Kode"),
    /*#__PURE__*/_createElementVNode("th", null, "Jenis"),
    /*#__PURE__*/_createElementVNode("th", null, "Titik Peta"),
    /*#__PURE__*/_createElementVNode("th", null, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"right"} }, "Aksi")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"min-width":"60px"} }
const _hoisted_11 = { class: "flex items-center gap-4 justify-end" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Oops, belum ada data terminal / halte di kota ini")
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderCustom = _resolveComponent("HeaderCustom")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ModalTerminal = _resolveComponent("ModalTerminal")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!
  const _component_CityForm = _resolveComponent("CityForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "card-no-shadow city-terminals wrap-hjp-data-list" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_HeaderCustom, {
            titleHeader: _ctx.title,
            titleButton: _ctx.titleButton,
            onRedirectAdd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCityAct())),
            onOnSearch: _ctx.onSearch,
            placeholder: "Cari Disini..."
          }, null, 8, ["titleHeader", "titleButton", "onOnSearch"])
        ])
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mb-8",
            key: idx
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(`${item.CityName}`) + " ", 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  class: "flex items-center gap-2 extra-submit-button",
                  onClick: ($event: any) => (_ctx.addNew(item)),
                  outlined: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.icon.svg.plusBlueEva,
                      class: "text-primary"
                    }, null, 8, _hoisted_4),
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                (item.IsHasStation)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Stations, (terminal, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("td", null, _toDisplayString(terminal.Name), 1),
                          _createElementVNode("td", null, _toDisplayString(terminal.Code ?? '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(terminal.Type), 1),
                          _createElementVNode("td", null, _toDisplayString(`${terminal.Latitude}, ${terminal.Longitude}`), 1),
                          _createElementVNode("td", null, _toDisplayString(terminal.Description), 1),
                          _createElementVNode("td", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "edit",
                                  class: "cursor-pointer mb-2 lg:mb-0",
                                  style: {"width":"35px","height":"35px","min-width":"35px"},
                                  onClick: ($event: any) => (_ctx.terminalEdit(terminal))
                                }, null, 8, _hoisted_12)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_13, _hoisted_15))
              ])
            ])
          ]))
        }), 128)),
        (_ctx.dataSource.length === 0)
          ? (_openBlock(), _createBlock(_component_EmptyState, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        (_ctx.dataSource.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filter.pageSize,
              totalRecords: _ctx.filter.totalRecords,
              onOnPage: _ctx.onChangePage
            }, null, 8, ["rows", "totalRecords", "onOnPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListActions, {
          edit: true,
          del: false,
          onDel: _ctx.onDelete,
          onEdit: _ctx.showModalFormAct
        }, null, 8, ["onDel", "onEdit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ModalTerminal, {
      show: _ctx.showModal,
      onHideDialog: _ctx.hideDialog,
      onOnSubmit: _ctx.onSubmit
    }, null, 8, ["show", "onHideDialog", "onOnSubmit"]),
    _createVNode(_component_HjpConfirmationModal, {
      show: _ctx.attrModalConfirmation.show,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onOnSubmit: _ctx.doDelete,
      onHideDialog: _ctx.hideConfirmModal
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "onOnSubmit", "onHideDialog"]),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (_ctx.showModalForm)
        ? {
            name: "form",
            fn: _withCtx(() => [
              _createVNode(_component_CityForm)
            ])
          }
        : undefined
    ]), 1032, ["show"])
  ]))
}